import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Home from "./pages/Home";
import NearbyHotels from "./pages/NearbyHotels";
import Login from "./auth/Login";
import Register from "./auth/Register";
import "./App.css";
import OtpVerfication from "./auth/Register/OtpVerification";
import About from "./pages/About";
import HotelBooking from "./pages/HotelBooking";
import GuestMenu from "./pages/HotelBooking/GuestMenu";
import HotelDetail from "./pages/HotelBooking/Hoteldetail";
import RestaurantOrdering from "./pages/RestaurantOrdering";
import RestaurantDetail from "./pages/RestaurantOrdering/RestaurantDetail";
import Tableconfirmation from "./pages/RestaurantOrdering/RestaurantDetail/TabSelection/BooKTable/TableConfirmation";
import TableCode from "./pages/RestaurantOrdering/RestaurantDetail/TabSelection/BooKTable/TableConfirmation/TableCode";
import CartStep from "./pages/Cart/CartStep";
import OrderConfirmation from "./pages/Cart/OrderConfirmation";
import TrackOrder from "./pages/Cart/TrackOrder";
import UserProfile from "./pages/UserProfile";
import Layout from "./Layout";
import Dashboard from "./pages/Userpannel/UserDashboard";
import RoomListing from "./pages/Userpannel/RoomListing";
import AddNewRoom from "./pages/Userpannel/RoomListing/AddNewRoom";
import AddNewHotel from "./pages/Userpannel/AddNewHotel";
import UserHotelDetail from "./pages/Userpannel/AddNewHotel/UserHotelDetail";
import Restaurant from "./pages/Userpannel/Restaurant";
import SettingsUsers from "./pages/Userpannel/SettingsUsers";
import AddNewRestaurant from "./pages/Userpannel/Restaurant/AddNewRestaurant";
import Addrstaurantmenu from "./pages/Userpannel/Restaurant/AddRestaurantMenu";
import AddHotelmenu from "./pages/Userpannel/AddNewHotel/HotelMenu";
import Orders from "./pages/Userpannel/Orders";
import ForHotels from "./pages/Userpannel/Reservation/ForHotels";
import ForRestaurants from "./pages/Userpannel/Reservation/ForRestaurants";
import CustomerSupport from "./pages/Userpannel/CustomerSupport";
import ReviewAndFeedback from "./pages/Userpannel/ReviewAndFeedback";
import ManageHotels from "./pages/Userpannel/SubAdminRoles/ManageHotels";
import ManageRestaurants from "./pages/Userpannel/SubAdminRoles/ManageRestaurants";
import RestaurantOffers from "./pages/Userpannel/Promotions/RestaurantOffers";
import HotelOffers from "./pages/Userpannel/Promotions/HotelOffers";
import AdminDashboard from "./pages/AdminPannnel/AdminDashboard";
import RestaurantManagement from "./pages/AdminPannnel/Restaurantmanagement";
import RestaurantDetailPage from "./pages/AdminPannnel/Restaurantmanagement/RestaurantDetailPage";
import HotelManagement from "./pages/AdminPannnel/Hotelmanagement";
import HotelDetailPage from "./pages/AdminPannnel/Hotelmanagement/HotelDetailPage/HotelDetailPage";
import AdminSubAdminRoles from "./pages/AdminPannnel/AdminSubAdminRoles";
import Support from "./pages/AdminPannnel/Support";
import AdminSettings from "./pages/AdminPannnel/AdminSettings";
import PromotionList from "./pages/AdminPannnel/PromotionList";
import PromotionDetail from "./pages/AdminPannnel/PromotionList/PromotionDetail";
import ProtectedRoute from "./ProtectedRoute";
import { userRoles } from "./helper/commanFunc";
import OwnerHotelPromotionDetail from "./pages/Userpannel/Promotions/HotelOffers/PromotionDetail/index";
import OwnerRestaurantPromotionDetail from "./pages/Userpannel/Promotions/HotelOffers/PromotionDetail/index";
import RestaurantSlots from "./pages/Userpannel/Restaurant/AddSlots";
import AdminCommissions from "./pages/AdminPannnel/Commissions";
import LanguageManagement from "./pages/AdminPannnel/ManageLanguages";
import ReferralManagement from "./pages/AdminPannnel/ReferralManagement";
import UserManagement from "./pages/AdminPannnel/UserManagement";
import Checkout from "./pages/Checkout";
import FloorDesign from "./pages/FloorPlan";
import UserBookings from "./pages/HotelBooking/UserBookings";
import UserOrders from "./pages/HotelBooking/UserOrders";
import HotelMenu from "./pages/HotelBooking/HotelMenu";
import HotelCartStep from "./pages/Cart/CartStep/HotelCart";
import HotelCartGuest from "./pages/Cart/CartStep/HotelCartGuest";
import HotelOrders from "./pages/Userpannel/HotelOrders";
import Wallet from "./pages/Wallet";
import UserSupport from "./pages/UserSupport";
import ForgotPassword from "./auth/ForgotPassword";
import Terms from "../src/pages/Terms";
import Privacy from "../src/pages/Privacy";
import Paymentfailed from "../src/pages/Paymentfailed";
import MobilePaymentRedirect from "./pages/MobileAppRedirect";
import Sponsored from "./pages/AdminPannnel/Sponsored";
import AppNavigatorkkk from "./pages/AppNavigator/AppNavigator";

function App() {
  return (
    <Router>
      <Layout>
        <Routes>
          <Route
            path="/app-payment-redirect"
            element={<MobilePaymentRedirect />}
          />
          <Route path="/app-redirect" element={<AppNavigatorkkk />} />
          {/* Auth Routes */}
          <Route path="/" element={<Home />} />
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Register />} />
          <Route path="/otpverification" element={<OtpVerfication />} />
          <Route path="/forgotpassword" element={<ForgotPassword />} />

          <Route path="/about" element={<About />} />
          <Route path="/nearby-hotels" element={<NearbyHotels />} />
          <Route path="/hotelbooking" element={<HotelBooking />} />
          <Route path="/guest-hotel-menu" element={<GuestMenu />} />
          <Route path="/hotel-cart-guest" element={<HotelCartGuest />} />
          <Route path="/hoteldetail" element={<HotelDetail />} />
          <Route path="/restaurantordering" element={<RestaurantOrdering />} />
          <Route path="/restaurantdetail" element={<RestaurantDetail />} />
          <Route path="/cart" element={<CartStep />} />
          <Route path="/terms" element={<Terms />} />
          <Route path="/privacy" element={<Privacy />} />
          <Route path="/payment-failed" element={<Paymentfailed />} />

          <Route
            element={
              <ProtectedRoute
                allowedRole={[userRoles.admin, userRoles.owner, userRoles.user]}
              />
            }
          >
            <Route path="/user-bookings" element={<UserBookings />} />
            <Route path="/user-orders" element={<UserOrders />} />
            <Route path="/tableconfirmation" element={<Tableconfirmation />} />
            <Route path="/tablecode" element={<TableCode />} />
            <Route path="/orderconfirmation" element={<OrderConfirmation />} />
            <Route path="/trackorder" element={<TrackOrder />} />
            <Route path="/userprofile" element={<UserProfile />} />
            <Route path="/checkout" element={<Checkout />} />
            <Route path="/hotel-menu" element={<HotelMenu />} />
            <Route path="/hotel-cart" element={<HotelCartStep />} />
            <Route path="/usersupport" element={<UserSupport />} />
          </Route>

          {/* Owner Routes*/}
          <Route
            element={<ProtectedRoute allowedRole={[`${userRoles?.owner}`]} />}
          >
            <Route path="/ownerdashboard" element={<Dashboard />} />
            <Route path="/roomlisting" element={<RoomListing />} />
            <Route path="/addnewroom" element={<AddNewRoom />} />
            <Route path="/addnewhotel" element={<AddNewHotel />} />
            <Route
              path="/userhoteldetail/:hotelId"
              element={<UserHotelDetail />}
            />
            <Route path="/restaurant" element={<Restaurant />} />
            <Route path="/addnewrestaurant" element={<AddNewRestaurant />} />
            <Route path="/slots/:restaurantId" element={<RestaurantSlots />} />
            <Route path="/settingsusers" element={<SettingsUsers />} />
            <Route path="/addrestaurantmenu" element={<Addrstaurantmenu />} />
            <Route path="/addhotelmenu" element={<AddHotelmenu />} />
            <Route path="/orders" element={<Orders />} />
            <Route path="/hotel-orders" element={<HotelOrders />} />
            <Route path="/reservationforhotels" element={<ForHotels />} />
            <Route
              path="/reservationforrestaurants"
              element={<ForRestaurants />}
            />
            <Route path="/customersupport" element={<CustomerSupport />} />
            <Route path="/reviewandfeedback" element={<ReviewAndFeedback />} />
            <Route path="/managehotels" element={<ManageHotels />} />
            <Route path="/managerestaurants" element={<ManageRestaurants />} />
            <Route path="/restaurantoffers" element={<RestaurantOffers />} />
            <Route
              path="/restaurantofferdetail/:offerId"
              element={<OwnerRestaurantPromotionDetail />}
            />
            <Route path="/hoteloffers" element={<HotelOffers />} />
            <Route
              path="/hotelofferdetail/:offerId"
              element={<OwnerHotelPromotionDetail />}
            />
            <Route path="/floor-plan" element={<FloorDesign />} />
          </Route>

          {/* Admin Routes */}
          <Route
            element={<ProtectedRoute allowedRole={[`${userRoles?.admin}`]} />}
          >
            <Route path="/admindashboard" element={<AdminDashboard />} />
            <Route
              path="/restaurantmanagement"
              element={<RestaurantManagement />}
            />
            <Route path="/commissions" element={<AdminCommissions />} />
            <Route path="/language-management" element={<LanguageManagement />} />
            <Route path="/referral-management" element={<ReferralManagement />} />
            <Route
              path="/restaurantdetailpage/:restaurantId"
              element={<RestaurantDetailPage />}
            />
            <Route path="/hotelmanagement" element={<HotelManagement />} />
            <Route
              path="/hoteldetailpage/:hotelId"
              element={<HotelDetailPage />}
            />
            <Route
              path="/adminsubadminroles"
              element={<AdminSubAdminRoles />}
            />
            <Route path="/support" element={<Support />} />
            <Route path="/adminsettings" element={<AdminSettings />} />
            <Route path="/promotionslist" element={<PromotionList />} />
            <Route path="/sponsored" element={<Sponsored />} />
            <Route path="/usermanagement" element={<UserManagement />} />
            <Route
              path="/promotiondetail/:offerId"
              element={<PromotionDetail />}
            />
          </Route>

          <Route
            element={
              <ProtectedRoute
                allowedRole={[userRoles.admin, userRoles.owner]}
              />
            }
          >
            <Route path="/wallet" element={<Wallet />} />
          </Route>
        </Routes>
      </Layout>
    </Router>
  );
}

export default App;
